// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import sliderReducer from "./slices/sliderSlice";
import socialMediaReducer from "./slices/socialMediaSlice";
import footerReducer from "./slices/FooterSlice";
import galleriesReducer from "./slices/galleriesSlice";
import aboutReducer from "./slices/aboutSlice";
import orderReducer from "./slices/orderSlice";
import productCategoriesReducer from "./slices/productCategoriesSlice";
import productDetailsReducer from "./slices/productDetailsSlice";

const store = configureStore({
  reducer: {
    slider: sliderReducer,
    socialMedia: socialMediaReducer,
    footer: footerReducer,
    galleries: galleriesReducer,
    about: aboutReducer,
    order: orderReducer,
    productCategories: productCategoriesReducer,
        productDetails: productDetailsReducer,

  },
});

export default store;
